import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "input"]

  pick() {
    this.inputTarget.value = this.pickerTarget.value
  }
}
